import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addSalaryStructureHr = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Salary Structure',
    body
  );
  return data;
});
export const updateSalaryStructureHr = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Salary Structure/${id}`,
    body
  );
  return data;
});

export const getSalaryStructureHr = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Salary Structure?fields=["name","docstatus","payroll_frequency","mode_of_payment"]'
  );
  return data;
});
export const deleteSalaryStructureHr = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Salary Structure/${record}`
  );
  return data;
});
export const getSalaryStructureHrDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Salary Structure/${id}`
  );
  return data;
});
export const getSalaryComponent = catchAsync(async (name = '') => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.search?type=Salary Component&fields=["salary_component_abbr","statistical_component","depends_on_payment_days","exempted_from_income_tax","is_tax_applicable","is_flexible_benefit","variable_based_on_taxable_salary"]&name=${name}`
  );
  return data;
});
